/**
 * Explicações dos erros, anexadas aos solucionadores defeituosos.
 *
 * Ficam num mapa à parte, por código de erro, em vez de dentro de cada solucionador.
 * O solucionador diz COMO o erro calcula; a explicação diz COMO CONTAR ISSO AO ALUNO.
 * São dois textos com leitores diferentes — um é revisado por quem cuida da medida, o
 * outro por quem cuida da linguagem — e separá-los deixa cada um legível sozinho.
 *
 * Toda explicação recebe o VALOR que o solucionador produziu, para nunca divergir da
 * alternativa que o aluno viu na tela.
 */

import type { BuggySolver } from '../schema/item.ts';
import type { RichText } from '../schema/richtext.ts';

export type Explicacoes<P, A> = Readonly<Record<string, (params: P, value: A) => RichText>>;

export function comExplicacoes<P, A>(
  solvers: readonly BuggySolver<P, A>[],
  explicacoes: Explicacoes<P, A>,
): readonly BuggySolver<P, A>[] {
  return solvers.map((s) => {
    const e = explicacoes[s.error as string];
    return e ? { ...s, explain: e } : s;
  });
}
